/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const ResendRegistrationMailDocument = gql`
    mutation ResendRegistrationMail($companyId: Int!, $branchId: Int!, $employeeId: Int!) {
  resendRegistrationMail(
    companyId: $companyId
    branchId: $branchId
    employeeId: $employeeId
  )
}
    `;
export type ResendRegistrationMailMutationFn = Apollo.MutationFunction<ResendRegistrationMailMutation, ResendRegistrationMailMutationVariables>;

/**
 * __useResendRegistrationMailMutation__
 *
 * To run a mutation, you first call `useResendRegistrationMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendRegistrationMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendRegistrationMailMutation, { data, loading, error }] = useResendRegistrationMailMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useResendRegistrationMailMutation(baseOptions?: Apollo.MutationHookOptions<ResendRegistrationMailMutation, ResendRegistrationMailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendRegistrationMailMutation, ResendRegistrationMailMutationVariables>(ResendRegistrationMailDocument, options);
      }
export type ResendRegistrationMailMutationHookResult = ReturnType<typeof useResendRegistrationMailMutation>;
export type ResendRegistrationMailMutationResult = Apollo.MutationResult<ResendRegistrationMailMutation>;
export type ResendRegistrationMailMutationOptions = Apollo.BaseMutationOptions<ResendRegistrationMailMutation, ResendRegistrationMailMutationVariables>;
export type ResendRegistrationMailMutationVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
  employeeId: Types.Scalars['Int']['input'];
}>;


export type ResendRegistrationMailMutation = { __typename?: 'Mutation', resendRegistrationMail: boolean };
